module.exports = __webpack_public_path__ + "static/media/favicon.50627c00.png";